<template>
  <a @mouseenter="showSubMenu" @mouseleave="hideSubMenu" class="dropdown-item dropdown-workspace"
     :aria-expanded="isShowSubMenu">
    <WorkspaceCardSection :show-arrow="workspaceStore.getWorkspaceList.length > 1"
                          :workspace="workspaceStore.getSelectedWorkspace"/>
  </a>


  <ul @mouseenter="showSubMenu" @mouseleave="hideSubMenu"
      class="dropdown-menu dropdown-menu-workspace submenu show">
    <div v-if="isShowSubMenu && (workspaceStore.getWorkspaceList.length > 1 || !hasOwnedWorkspace())" class="dropdown-menu-box animation scrollbar">
      <li v-for="(workspace, index) in workspaceStore.getWorkspaceList" :key="index">
        <a class="dropdown-item dropdown-workspace"
           :class="{ 'active':  workspace.isActive}"
           @click="selectWorkspace(workspace)">
          <WorkspaceCardSection :workspace="workspace"/>
        </a>
      </li>
      <li v-if="!hasOwnedWorkspace()">
        <hr class="dropdown-divider">
      </li>
      <li v-if="!hasOwnedWorkspace()"><a @click="goToCreateWorkspace($event)" class="dropdown-item">Create a workspace</a>
      </li>
    </div>
  </ul>
</template>

<script lang="ts">

import {defineComponent} from 'vue';
import WorkspaceCardSection from '@shared/components/sections/workspace-card.section.vue';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useRegisterStore} from "@domains/auth/stores/register.store";
import {useUserStore} from "@shared/stores/user.store";
import {goToWorkspace} from "@shared/helpers";
import {WorkspaceNs} from "@shared/types";
import {useResetStores} from "@shared/composables/use-reset-stores";

export default defineComponent({
  name: 'DropdownWorkspaceItemSection',
  components: {
    WorkspaceCardSection,
  },
  setup() {
    // initialize the store
    const workspaceStore = useWorkspaceStore()
    const registerStore = useRegisterStore()
    const userStore = useUserStore()
    return {workspaceStore, registerStore, userStore}
  },
  data() {
    return {
      isShowSubMenu: false,
    };
  },
  computed: {},
  mounted() {
    if (!this.workspaceStore.getWorkspaceList || this.workspaceStore.getWorkspaceList.length == 0) {
      this.workspaceStore.loadUserWorkspaceList().then(() => {
      });
    }
  },
  methods: {
    selectWorkspace(selectedWorkspace: WorkspaceNs.Workspace) {
      if (!selectedWorkspace.isActive) {
        useResetStores().resetAll();
        goToWorkspace(selectedWorkspace, this.$router);
      }
    },
    hasOwnedWorkspace(): boolean {
      const ownedWs = this.workspaceStore.getWorkspaceList.find((ws: WorkspaceNs.Workspace) => ws.userRole === 'OWNER');
      return !!ownedWs;
    },
    goToCreateWorkspace(e: Event): void {
      this.registerStore.goToCreateWorkspace()
      this.userStore.getUserMe().then(() => {
      });

      e.preventDefault();
    },
    showSubMenu(): void {
      this.isShowSubMenu = true;
    },
    hideSubMenu(): void {
      this.isShowSubMenu = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.dropdown-menu {
  width: 250px;

  .dropdown-menu-box {
    width: 250px;
    padding: 0;
    overflow-y: auto;
    max-height: 240px;
  }
}

.dropdown-menu-workspace {
  left: 235px;
  top: 0;
}

</style>
